import * as Yup from 'yup';

export const LoginSchema = Yup.object().shape({
  username: Yup.string().required('Kullanıcı adı zorunlu'),
  password: Yup.string().required('Şifre zorunlu'),
  rememberMe: Yup.boolean(),
});
